module.exports = __webpack_public_path__ + "img/782-7c8a11.png";